// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-blog-post-js": () => import("./../../../src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-templates-month-archive-js": () => import("./../../../src/templates/month-archive.js" /* webpackChunkName: "component---src-templates-month-archive-js" */),
  "component---src-templates-year-archive-js": () => import("./../../../src/templates/year-archive.js" /* webpackChunkName: "component---src-templates-year-archive-js" */)
}

